import type { PublishJob } from '../../cataloglifecycle/framework';
import { ProgressFeedback } from '../motionxp/ProgressFeedback';
import { cn } from '../../lib/cn';

type Props = { jobs?: PublishJob[] };

function stateColor(state: PublishJob['state']) {
  switch (state) {
    case 'running': return 'text-brand-600';
    case 'completed': return 'text-success-600';
    case 'failed': return 'text-error-600';
    default: return 'text-slate-500';
  }
}

export function PublishingMonitorPanel({ jobs = [] }: Props) {
  const stats = {
    queued: jobs.filter((j) => j.state === 'queued').length,
    running: jobs.filter((j) => j.state === 'running').length,
    completed: jobs.filter((j) => j.state === 'completed').length,
    failed: jobs.filter((j) => j.state === 'failed').length,
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-4 text-sm">
        <span>Queued: <strong>{stats.queued}</strong></span>
        <span className="text-brand-600">Running: <strong>{stats.running}</strong></span>
        <span className="text-success-600">Completed: <strong>{stats.completed}</strong></span>
        <span className="text-error-600">Failed: <strong>{stats.failed}</strong></span>
      </div>
      <ul className="space-y-3">
        {jobs.map((job) => (
          <li key={job.id}>
            <div className="flex justify-between text-sm">
              <span className="font-mono text-xs">{job.release}</span>
              <span className={cn('text-xs font-medium capitalize', stateColor(job.state))}>{job.state}</span>
            </div>
            <p className="text-xs text-slate-500">{job.detail}</p>
            {(job.state === 'running' || job.state === 'failed') && (
              <ProgressFeedback value={job.progress} showPercent className="mt-1" />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
